import React from 'react';
import { Box } from '@mui/material';
import HeroBanner from '../../components/home/hero-banner';
import { useHomeState } from '../context/home-context';

// Hero de largura total: fica fora de qualquer container, colado à navegação
export default function SectionBanner() {
  const { banners } = useHomeState();

  return (
    <Box component="section" aria-label="Destaques">
      <HeroBanner banners={banners} />
    </Box>
  );
}
